import { Box } from '@mui/material';

export default function ColorIndicator({ color }: { color: string }) {
    return (
        <Box
            sx={{
                width: 10,
                height: 10,
                borderRadius: '50%',
                bgcolor: color,
                border: '1px solid #ccc',
                alignSelf: 'center',
                flexShrink: 0,
            }}
        />
    );
}
